// Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
// section image
import introImg from "../Images/intro.jpg";

// The Landing page only displays hardcoded values and uses an image from the image directory in src.
function LandingPage() {
  return (
    <section className="landing-page">
      <Container>
        <h1 className="section-heading">THE RESTAURANT</h1>
        <p className="text-center">
          A little about us and a brief history of how we started.
        </p>

        <div className="section-border pb-3"></div>
        <Row>
          <Col>
            <img className="img-fluid" src={introImg} alt="" />
          </Col>
          <Col>
            <p>
              Cras ut viverra eros. Phasellus sollicitudin sapien id luctus
              tempor. Sed hend rerit inter dum sagittis. Donec nunc lacus,
              dapibus nec interdum eget, ultrices eget justo. Nam purus lacus,
              efficitur eget laoreet sed, finibus nec neque. Cras eget enim in
              diam dapibus sagittis. In massa est, dignissim in libero ac,
              fringilla ornare mi. Etiam interdum ligula purus. Ultrices eget
              justo. Nam purus lacus, efficitur eget laoreet sed, finibus nec
              neque. Cras eget enim in diam dapibus sagittis. In massa est,
              dignissim in libero ac, fringilla ornare.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default LandingPage;
